import React from "react";
import { StyleSheet, Text } from "react-native";
export const Paragraph = ({ children, style, ...props }) => (<Text {...props} style={[styles.paragraph, style]}>
    {children}
  </Text>);
const styles = StyleSheet.create({
    paragraph: {
        fontSize: 24,
        letterSpacing: 0.25,
        marginVertical: 2,
    },
});
//# sourceMappingURL=Paragraph.js.map